module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai_hiratsuka/arrow_caption-eb31a06a1990702379f627aefbf92854.gif";